// tanstack
import { useParams } from '@tanstack/react-router';

// material ui
import { Grid } from '@mui/material';
import { Stack } from '@mui/system';

// api
import { useGetEnergyGroupsQuery } from '@/api/generated/recalc/endpoints/v2/energyGroups';

// shared components
import PageContainer from '@/components/layout/PageContainer';

// feature-components
import DeepDiveModule from '@/features/energyxplorer/components/portfolio-dashboard/DeepDiveModule';
import AlarmCard from '@/features/energyxplorer/components/sales-cards/AlarmCard';

// components
import { useHasService } from '@/hooks/useHasService';

// rtk query
import { skipToken } from '@reduxjs/toolkit/query';

const DeepDiveDashboardPage = () => {
  const { accountId } = useParams({ strict: false });
  const numericAccountId = accountId ? Number(accountId) : undefined;

  const { currentData: energyGroups } = useGetEnergyGroupsQuery(
    numericAccountId ? { accountIds: [numericAccountId] } : skipToken,
  );

  const { hasService: hasAnalyticsService, isLoading } = useHasService(
    'EnergyXplorerAnalytics',
  ) as unknown as {
    hasService: boolean;
    isLoading: boolean;
  };

  return (
    <PageContainer sx={{ py: 2 }}>
      <Stack spacing={2}>
        <DeepDiveModule
          accountId={accountId}
          energyGroups={energyGroups}
          hasAnalyticsService={hasAnalyticsService}
        />

        {!hasAnalyticsService && !isLoading && (
          <Grid container spacing={1} sx={{ mt: 0.5 }}>
            <Grid size="grow">
              <AlarmCard />
            </Grid>
          </Grid>
        )}
      </Stack>
    </PageContainer>
  );
};

export default DeepDiveDashboardPage;
